export default {"src":"/_next/static/media/cursor-arrow-rays.066b387f.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};